import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const TYPING_SPEED = 150;
const DELETING_SPEED = 50;
const STAY_DURATION = 6000;

const styles = theme => ({
    cursor: {
        borderLeft: ".1em solid #fff",
        animation: "blink 1.5s steps(1) infinite",
    },
    text: {
        background: `linear-gradient(42deg, ${theme.palette.gradient.one} -30%, ${theme.palette.gradient.two} 90%)`,
        //background: "-webkit-linear-gradient(#eee, #333)",
        '-webkitBackgroundClip': "text",
        textFillColor: "transparent",
    }
});

class Typer extends React.Component {
    state = {
        text: '',
        isDeleting: false,
        loopNum: 0,
        typingSpeed: TYPING_SPEED,
        textStyle: this.props.classes.text,
    }

    componentDidMount() {
        this.handleType();
    }

    handleType = async () => {

        await this.sleep(1000);

        while (true) {
            const { dataText } = this.props;
            const { isDeleting, loopNum, text, typingSpeed } = this.state;
            const i = loopNum % dataText.length;
            const fullText = dataText[i];

            this.setState({
                text: isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1),
                typingSpeed: isDeleting ? DELETING_SPEED : TYPING_SPEED
            });

            if (!isDeleting && text === fullText) {
                //setTimeout(() => this.setState({ isDeleting: true }), STAY_DURATION);
                this.setState({ isDeleting: true });
                await this.sleep(STAY_DURATION);
                continue;
            } else if (isDeleting && text === '') {
                this.setState({
                    isDeleting: false,
                    loopNum: loopNum + 1
                });
            }

            await this.sleep(typingSpeed);
        }
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    render() {
        const { classes } = this.props;
        return (
            <Typography variant="h2">{this.props.heading}&nbsp;
                <b className={this.state.textStyle}>{this.state.text}</b>
                <span className={classes.cursor}></span>
            </Typography>
        );
    }
};

export default withStyles(styles, { withTheme: true })(Typer);